import React from "react";

import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";

import { IconButton, Typography } from "@material-ui/core";

import SvgI24Edit from "assets/icons/I24Edit";

import TrimmedText from "components/TrimmedText";

import {
  Container,
  ControlsContainer,
  ControlWrapper,
  DetailsContainer,
  Menu,
  MenuControlWrapper,
  TextContainer,
  TitleWrapper,
} from "./styles";
import SvgI24Menu from "assets/icons/I24Menu";
import { DraggableProvidedDragHandleProps } from "react-beautiful-dnd";

type Props = {
  title: string;
  details?: any;
  onRemove?: () => void;
  closePopup?: () => void;
  isPopupOpen?: () => void;
  isDragging?: boolean;
  isEditMode?: boolean;
  dragHandleProps?: DraggableProvidedDragHandleProps;
  innerRef?: any;
};

class OptionCard extends React.Component<Props> {
  render() {
    const {
      title,
      details,
      dragHandleProps,
      isDragging,
      isEditMode,
      innerRef,
      isPopupOpen,
      onRemove,
      ...restProps
    } = this.props;

    return (
      <>
        <Container
          isEditMode={isEditMode}
          ref={innerRef}
          isDragging={isDragging}
          {...restProps}
        >
          <DetailsContainer>
            <TextContainer>
              <TitleWrapper>
                <TrimmedText lines={1} text={title}>
                  <Typography variant="h4" color="textPrimary">
                    {title}
                  </Typography>
                </TrimmedText>
              </TitleWrapper>
            </TextContainer>
          </DetailsContainer>
          {isEditMode && (
            <>
              <ControlsContainer>
                <ControlWrapper>
                  <IconButton color="secondary" onClick={isPopupOpen}>
                    <SvgI24Edit />
                  </IconButton>
                </ControlWrapper>
              </ControlsContainer>
              <ControlsContainer>
                <ControlWrapper>
                  <IconButton color="secondary" onClick={onRemove}>
                    <DeleteOutlineIcon />
                  </IconButton>
                </ControlWrapper>
              </ControlsContainer>

              <MenuControlWrapper>
                <Menu {...dragHandleProps}>
                  <SvgI24Menu />
                </Menu>
              </MenuControlWrapper>
            </>
          )}
        </Container>
      </>
    );
  }
}

export default OptionCard;
